import { useTranslation } from 'react-i18next'

import { IconUpcomingLive } from 'assets/svg/sprite'
import { formatedDate } from 'lib/dayjs'
import { type ILiveFile } from 'types/interfaces/ILiveFile'

import styles from './mediaItemLive.module.scss'

interface Props {
    live: ILiveFile
}

export const MediaItemLive = ({ live }: Props) => {
    const { img_url: url, schedule_date } = live

    const { t } = useTranslation()
    return (
        <div className={styles.wrapper}>
            <img src={url} alt='media' />
            {schedule_date && (
                <div className='post__files__file__upcoming'>
                    <IconUpcomingLive />
                    <p>{t('upcomingLiveStream')}</p>
                    <div className='post__files__file__upcoming__date'>
                        {formatedDate(schedule_date, 'MMM D, h:mm A')}
                    </div>
                </div>
            )}
        </div>
    )
}
